import dynamic from 'next/dynamic';

const LogisticsGrid = dynamic(() => import('./LogisticsGrid'));
const LogisticsForm = dynamic(() => import('./LogisticsForm/LogisticsForm'));
const LogisticsEditPage = dynamic(() =>
  import('./LogisticsEditPage/LogisticsEditPage')
);
const LogisticsAddPage = dynamic(() =>
  import('./LogisticsAddPage/LogisticsAddPage')
);

export { LogisticsGrid, LogisticsForm, LogisticsAddPage, LogisticsEditPage };
